const API_URL = process.env.REACT_APP_API_URL || 'https://apimon.mf-league.com/api';
const IMAGE_BASE = (process.env.REACT_APP_IMAGE_BASE_URL || API_URL.replace(/\/api\/?$/, '')).replace(/\/$/, '');

export function normalizeUploadPath(imagePath) {
  if (!imagePath || typeof imagePath !== 'string') return null;

  const trimmed = imagePath.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('blob:')) {
    return trimmed;
  }

  let normalized = trimmed.replace(/\\/g, '/').replace(/^\.?\//, '');
  normalized = normalized.replace(/^(app\/uploads\/|uploads\/|\.\/app\/uploads\/)/i, '');
  return normalized.replace(/^\//, '');
}

export function getImageUrlCandidates(imagePath) {
  const normalized = normalizeUploadPath(imagePath);
  if (!normalized) return [];
  if (normalized.startsWith('http://') || normalized.startsWith('https://') || normalized.startsWith('blob:')) {
    return [normalized];
  }

  return [
    `${IMAGE_BASE}/${normalized}`,
    `${IMAGE_BASE}/uploads/${normalized}`,
    `${IMAGE_BASE}/app/uploads/${normalized}`,
  ];
}

export function getImageUrl(imagePath) {
  const candidates = getImageUrlCandidates(imagePath);
  return candidates[0] || null;
}

/** Prefer largest available team logo for list/overview display. */
export function getBestTeamLogo(misc) {
  const parsed = parseMisc(misc);
  if (!parsed) return null;
  return parsed.logoBig || parsed.logoSmall || parsed.dress || parsed.logo || null;
}

export function parseMisc(misc) {
  if (!misc) return null;
  if (typeof misc === 'string') {
    try {
      return JSON.parse(misc);
    } catch {
      return null;
    }
  }
  if (typeof misc === 'object') return misc;
  return null;
}

export function getTeamLogoField(misc, path) {
  if (!misc || !path) return null;
  if (misc.logoBig === path) return 'logoBig';
  if (misc.logoSmall === path) return 'logoSmall';
  if (misc.dress === path) return 'dress';
  return null;
}
